import { Menu, Box } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { IconDeviceFloppy, IconDotsVertical, IconPencil, IconTrash } from "@tabler/icons";
import { useContext, useMemo, useState } from "react";
import FiltersContext from "./filters/context/FiltersContext";
import { getConnectedUserRole } from "../../utils";
import { filtersAreSame, getFiltersToSave } from "../../utils/viewUtils";
import { useCurrentUser } from "../../hooks/useCurrentUser";


const TabMenu = ({
  item,
  upsertViews,
  onOpenSaveViewModal,
  onOpenChange,
  activeFilters,
}: {
  item: any;
  upsertViews: (body: any, func: (res: any) => void) => void;
  onOpenSaveViewModal: () => void;
  onOpenChange?: (opened: boolean) => void;
  activeFilters?: any[];
}) => {
  const [opened, setOpened] = useState(false);
  const { subPageKey } = useContext(FiltersContext);
  const currentUser = useCurrentUser();
  const canEdit = getConnectedUserRole(currentUser) === "admin";

  
  const filtersToSave = useMemo(
    () => getFiltersToSave(activeFilters || [], item.filters || []),
    [activeFilters, item.filters]
  );

  const filtersChanged = useMemo(
    () => !filtersAreSame(filtersToSave, (item.filters || []).filter((f: any) => !f.default)),
    [filtersToSave, item.filters]
  );

  const handleOpenSaveViewModal = () => {
    onOpenSaveViewModal();
    setOpened(false);
  };



  const showMenu = !item?.isGlobal || (item.isGlobal && canEdit);

  if (!showMenu) {
    return <Box pl={3} w={13} sx={{ display: 'flex', alignItems: 'center' }} />;
  }

  return (
    <Menu
      styles={{
        dropdown: {
          marginTop: -4,
        },
      }}
      shadow="md"
      opened={opened}
      onChange={(val) => {
        setOpened(val);
        onOpenChange?.(val);
      }}
    >
      <Menu.Target>
        <Box pl={3} sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => setOpened((prev: boolean) => !prev)}>
          <IconDotsVertical size={13} />
        </Box>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          icon={<IconPencil size={14} />}
          onClick={handleOpenSaveViewModal}
        >
          Edit
        </Menu.Item>
        <Menu.Item
          icon={<IconDeviceFloppy size={14} />}
          disabled={!filtersChanged}
          onClick={() => {
            upsertViews({ _id: item._id, filters: filtersToSave, subPageKey }, (res) => {
              setOpened(false);
            });
          }}
        >
          Save current filter
        </Menu.Item>
        <Menu.Item
          color="red"
          icon={<IconTrash size={14} />}
          onClick={() => {
            upsertViews({ _id: item._id, deleted: true, subPageKey: subPageKey }, (res) =>{
              console.log(res)
              showNotification({
                title: "deleted successfully!",
                color:"teal",
                message: "view deleted successfully",
                icon:<IconTrash size="1.1rem" />,
                autoClose: 1200
              })}
            );
          }}
        >
          Delete
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default TabMenu;
